export default 'smsTemplatesPage';
